import { MOKA_OPEN_API_HOST } from '../constants';

export const V1_MARKETPLACES = `${MOKA_OPEN_API_HOST}/v1/marketplaces`;
export const V1_PUBLIC_MARKETPLACES = `${MOKA_OPEN_API_HOST}/v1/public/marketplaces`;
